(function () {
  if (window.__bcWarehouseStockBound) return;
  window.__bcWarehouseStockBound = true;

  var config = window.BCWarehouseStock || {};
  var root = window.Shopify && window.Shopify.routes && window.Shopify.routes.root ? window.Shopify.routes.root : '/';

  function locKind(name) {
    var loc = String(name || '').toLowerCase();
    if (loc.indexOf('repar') !== -1 || loc.indexOf('répar') !== -1) return 'ignore';
    if (loc.indexOf('en mer') !== -1 || loc.indexOf('stock inde') !== -1 || loc.indexOf('india') !== -1 || loc.indexOf('inde') !== -1) {
      return 'transit';
    }
    if (loc === 'france' || loc.indexOf('mimet') !== -1) return 'france';
    return 'other';
  }

  function classifyLevels(levels) {
    var france = 0;
    var transit = 0;
    var saw = false;
    (levels || []).forEach(function (level) {
      saw = true;
      var qty = Number(level.available);
      if (isNaN(qty) || qty < 0) qty = 0;
      var kind = locKind(level.name);
      if (kind === 'france') france += qty;
      if (kind === 'transit') transit += qty;
    });
    if (france > 0) return 'france';
    if (transit > 0) return 'transit';
    if (saw) return 'production';
    return '';
  }

  function classifyPayload(payload) {
    if (!payload) return '';
    var fromLevels = classifyLevels(payload.levels);
    if (fromLevels) return fromLevels;
    var fromStores = classifyLevels(payload.stores);
    if (fromStores === 'france' || fromStores === 'transit') return fromStores;
    if (Number(payload.france_qty) > 0) return 'france';
    if (Number(payload.india_qty) > 0) return 'transit';
    var origin = String(payload.origin || '').toLowerCase();
    if (origin === 'france' || origin === 'mimet') return 'france';
    if (origin === 'transit' || origin === 'mer' || origin === 'inde' || origin === 'india' || origin.indexOf('achemin') !== -1) {
      return 'transit';
    }
    if (origin === 'production') return 'production';
    if (Number(payload.qty) > 0) return 'france';
    if (payload.incoming) return 'transit';
    return '';
  }

  function applyOrigin(box, origin) {
    if (!origin || !config.labels || !config.labels[origin]) return;
    var label = box.querySelector('[data-warehouse-label]');
    var dot = box.querySelector('[data-warehouse-dot]');
    var bar = box.querySelector('[data-warehouse-bar]');
    if (label) {
      var customTransit = box.getAttribute('data-transit-label');
      if (origin === 'transit' && customTransit) {
        label.textContent = customTransit;
      } else {
        label.textContent = config.labels[origin];
      }
    }
    if (dot && config.dots) {
      dot.innerHTML = origin === 'production' ? config.dots.amber : config.dots.green;
    }
    if (bar) {
      var fill = origin === 'france' ? '80%' : origin === 'transit' ? '50%' : '30%';
      bar.style.setProperty('--stock-fill', fill);
    }
    box.setAttribute('data-origin', origin);
    box.classList.toggle('preorder-box', origin === 'production');
  }

  function parseSection(html) {
    var doc = new DOMParser().parseFromString(html, 'text/html');
    var payload = doc.querySelector('[data-warehouse-stock-payload]');
    if (!payload) return null;
    try {
      return JSON.parse(payload.textContent);
    } catch (error) {
      return null;
    }
  }

  function fetchSection(variantId) {
    return fetch(root + 'variants/' + variantId + '/?section_id=warehouse-stock')
      .then(function (response) {
        if (!response.ok) return null;
        return response.text();
      })
      .then(parseSection)
      .catch(function () {
        return null;
      });
  }

  function fetchStorefront(handle, variantId) {
    if (!config.token || !handle) return Promise.resolve('');
    var gid = 'gid://shopify/ProductVariant/' + variantId;
    var query =
      'query WarehouseStock($handle: String!) { product(handle: $handle) { variants(first: 20) { nodes { id storeAvailability(first: 20) { nodes { quantityAvailable location { name } } } } } } }';
    return fetch('/api/2025-01/graphql.json', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        'X-Shopify-Storefront-Access-Token': config.token
      },
      body: JSON.stringify({ query: query, variables: { handle: handle } })
    })
      .then(function (response) {
        return response.json();
      })
      .then(function (json) {
        var nodes = (((json || {}).data || {}).product || {}).variants || {};
        var variants = nodes.nodes || [];
        var match = variants.filter(function (item) {
          return item.id === gid;
        })[0] || variants[0];
        if (!match) return '';
        var levels = ((match.storeAvailability || {}).nodes || []).map(function (item) {
          return {
            name: (item.location && item.location.name) || '',
            available: typeof item.quantityAvailable === 'number' ? item.quantityAvailable : 0
          };
        });
        return classifyLevels(levels);
      })
      .catch(function () {
        return '';
      });
  }

  function init() {
    document.querySelectorAll('[data-warehouse-stock]').forEach(function (box) {
      var variantId = box.getAttribute('data-variant-id');
      var handle = box.getAttribute('data-product-handle');
      if (!variantId) return;
      fetchSection(variantId)
        .then(function (payload) {
          var origin = classifyPayload(payload);
          if (origin) {
            applyOrigin(box, origin);
            return '';
          }
          return fetchStorefront(handle, variantId);
        })
        .then(function (origin) {
          if (origin === 'france' || origin === 'transit' || origin === 'production') {
            applyOrigin(box, origin);
          }
        });
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
